import { c as _c } from "react/compiler-runtime";
import LocationSelectorButton from "src/components/locationselector/LocationSelectorButton";
import { MySelectedLocationsList } from "src/components/locationselector/MySelectedLocations";
import styles from './Selectors.module.css';

//#region [Props]
type SelectorsProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function Selectors(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.SButtons}><MySelectedLocationsList className={styles.SelectedLocations}><LocationSelectorButton showTextLabel={true} className={styles.LocationButton} /></MySelectedLocationsList></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <div className={className}>{t1}</div>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
//#endregion

//#region [Styles]
// Converted to CSS Modules (Selectors.module.css)
//#endregion